const firebaseConfig = {
  apiKey: "AIzaSyA-Gc5zMkdi6CmrJdN_W8pzXTHo8VZzrbs",
  authDomain: "quick-connect-e4662.firebaseapp.com",
  projectId: "quick-connect-e4662",
  storageBucket: "quick-connect-e4662.firebasestorage.app",
  messagingSenderId: "720628086272",
  appId: "1:720628086272:web:b4ea8da18520e8e4b44ae5",
};

export default firebaseConfig;
